module.exports = __webpack_public_path__ + "img/1.7b89e3a7.png";